<template>
  <div>
    <div class="card" v-if="client_id !== null">
      <div class="card-body">
        <template v-if="isLoading">
          <div class="row text-left">
            <i
              class="fas fa-circle-notch fa-spin text-secondary ss-loading-icon"
            />
          </div>
        </template>

        <template v-else>
          <div class="row text-info">
            <div class="col-md-6">
              <small
                ><i class="fas fa-file-invoice-dollar"></i> Contas a
                receber:</small
              >
            </div>
            <div class="col-md-6 text-right">
              {{ response.dueTotal.sum_due_value | decimal }}
            </div>
          </div>

          <div class="row text-danger">
            <div class="col-md-6">
              <small
                ><i class="fas fa-credit-card"></i> Limite de crédito
                restante:</small
              >
            </div>
            <div class="col-md-6 text-right">
              {{
                (response.person_limit.debt_limit_value -
                  response.dueTotal.sum_due_value)
                  | decimal
              }}
            </div>
          </div>

          <div class="row" v-if="response.overDueTotal.sum_due_value != null">
            <div class="col-md-6">
              <small class="text-danger"
                ><i class="fas fa-exclamation-circle"></i> Total vencido:</small
              >
            </div>
            <div class="col-md-6 text-right text-danger">
              {{ response.overDueTotal.sum_due_value | decimal }}
            </div>
          </div>

          <div
            class="row"
            v-if="
              this.$store.state.company
                .order_block_clients_with_overdued_bill_after_days <=
              response.overDueDaysTotal.dias_atraso
            "
          >
            <div class="col-md-6">
              <small class="text-danger"
                ><i class="fas fa-exclamation-circle"></i> Cliente Bloqueado por
                atraso:</small
              >
            </div>
            <div class="col-md-6 text-right text-danger">
              {{ response.overDueDaysTotal.dias_atraso }} dias
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Filter from "../../../mixins/Form.js";

export default {
  props: {
    client_id: {},
  },

  data: function () {
    return {
      response: {
        dueTotal: 0,
        overDueTotal: 0,
        overDueDaysTotal: {},
        person_limit: {},
      },
      isLoading: false,
    };
  },

  mounted() {
    if (this.client_id) {
      this.select(this.client_id);
    }
  },

  watch: {
    client_id(client_id) {
      this.select(client_id);
    },

    // dueDays(NewValue){
    //     this.$emit('due_day', NewValue);
    // }
  },

  computed: {
    show() {
      return this.response != null;
    },

    // dueDays(){

    //  if(this.response.overDueDaysTotal != null){
    //      return this.response.overDueDaysTotal.dias_atraso
    //  }
    // }
  },

  methods: {
    select(client_id) {
      this.isLoading = true;
      this.response = null;
      axios
        .post(process.env.BASE_URL + "api/personstats/select", {
          client_id: this.client_id,
        })
        .then((response) => {
          this.response = response.data;

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
</style>
